var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C95.04 0 190.08 0 288 0 C288 21.12 288 42.24 288 64 C309.12 64 330.24 64 352 64 C352 106.24 352 148.48 352 192 C436.48 192 520.96 192 608 192 C608 371.52 608 551.04 608 736 C386.24 736 164.48 736 -64 736 C-64 514.24 -64 292.48 -64 64 C-42.88 64 -21.76 64 0 64 C0 42.88 0 21.76 0 0 Z M32 32 C32 53.12 32 74.24 32 96 C10.88 96 -10.24 96 -32 96 C-32 296.64 -32 497.28 -32 704 C15.52 704 63.04 704 112 704 C112 667.04 112 630.08 112 592 C133.12 592 154.24 592 176 592 C176 628.96 176 665.92 176 704 C223.52 704 271.04 704 320 704 C320 503.36 320 302.72 320 96 C298.88 96 277.76 96 256 96 C256 74.88 256 53.76 256 32 C182.08 32 108.16 32 32 32 Z M352 224 C352 382.4 352 540.8 352 704 C425.92 704 499.84 704 576 704 C576 545.6 576 387.2 576 224 C502.08 224 428.16 224 352 224 Z ",
    fill: "#666666",
    transform: "translate(128,32)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 26.4 32 52.8 32 80 C21.44 80 10.88 80 0 80 C0 53.6 0 27.2 0 0 Z ",
    fill: "#666666",
    transform: "translate(352,624)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 26.4 32 52.8 32 80 C21.44 80 10.88 80 0 80 C0 53.6 0 27.2 0 0 Z ",
    fill: "#666666",
    transform: "translate(160,624)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(352,528)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(288,528)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(224,528)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(160,528)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(352,432)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(288,432)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(224,432)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(160,432)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(352,336)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(288,336)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(224,336)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(160,336)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(352,240)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(288,240)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(224,240)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 21.12 32 42.24 32 64 C21.44 64 10.88 64 0 64 C0 42.88 0 21.76 0 0 Z ",
    fill: "#666666",
    transform: "translate(160,240)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(640,672)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(576,672)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(512,672)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(640,608)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(576,608)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(512,608)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(640,544)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(576,544)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(512,544)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(640,480)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(576,480)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(512,480)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(640,416)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(576,416)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(512,416)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(640,352)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(576,352)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(512,352)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(640,288)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(576,288)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(512,288)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(352,160)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(288,160)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(224,160)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C10.56 0 21.12 0 32 0 C32 10.56 32 21.12 32 32 C21.44 32 10.88 32 0 32 C0 21.44 0 10.88 0 0 Z ",
    fill: "#666666",
    transform: "translate(160,160)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.db0758065c22be356119cd831ba361fe.svg";
export { ForwardRef as ReactComponent };